import React from "react";
import CardTable from "../../../components/table/CardTable";
import columns from "./ManagementHistoryTableConfig";
import { useTranslation } from 'react-i18next';

const ManagementHistoryTable = ({ id, reload }) => {

  const { t } = useTranslation();

  return (
    <>


      <CardTable
        shadow={true}
        reload={reload}
        tittle={t("common.history")}
        source={"/actionHistory/" + id}
        columns={columns}
        externalState={id}
        setLoader={() => {
        }}
      />

    </>
  );
};

export default ManagementHistoryTable;